/* unplugin-vue-components disabled */import { render } from "./collect_list.vue?vue&type=template&id=7dd55eae&scoped=true"
import script from "./collect_list.vue?vue&type=script&lang=js"
export * from "./collect_list.vue?vue&type=script&lang=js"

import "./collect_list.vue?vue&type=style&index=0&id=7dd55eae&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd55eae"]])

export default __exports__